import { register } from "../navigation/navbar/ll/authentication/register";
import { signIn } from "../navigation/navbar/ll/authentication/signIn";
import { potentialWell } from "./potentialWell";
export var shared = {
    potentialWell: function (args) { return potentialWell(args); },
    signIn: function (args) { return signIn(args); },
    register: function (args) { return register(args); }
};
